import { Network } from ':fat/core/networks';
import { reconstructTransactions } from ':fat/workers/blockchain/transactions/reconstruct';

// These messages are the ones that can be sent to the blockchain worker
export type Message =
  | { kind: 'SETUP'; databaseWorkerPort: MessagePort }
  | { kind: 'SANITY_CHECK' }
  | { kind: 'PING' }
  | { kind: 'PONG' }
  | { kind: 'QUERY_RESULT'; result: unknown }
  | { kind: 'QUERY_ERROR'; error: string }
  | { kind: 'SET_DEVTOOL_STATE'; state: typeof self.DEVTOOL_STATE }
  | { kind: 'START_SCANNING'; fingerprint: number }
  | { kind: 'GET_SCANNING_PROGRESS' }
  | {
      kind: 'CONSTRUCT_TRANSACTIONS';
      fingerprint: number;
      destinations: Partial<Record<Network, string>>;
    };

export async function setup(databaseWorkerPort: MessagePort) {
  return MessageBus.send(
    'blockchainWorker',
    { kind: 'SETUP', databaseWorkerPort },
    { expectReply: 'READY' },
  );
}

export async function sanityCheck() {
  return MessageBus.send(
    'blockchainWorker',
    { kind: 'SANITY_CHECK' },
    { expectReply: 'SANITY_CHECK_RESPONSE' },
  );
}

export async function ping() {
  return MessageBus.send('blockchainWorker', { kind: 'PING' }, { expectReply: 'PONG' });
}

export async function constructTransactions(
  fingerprint: number,
  destinations: Partial<Record<Network, string>>,
) {
  const { txs } = await MessageBus.send(
    'blockchainWorker',
    { kind: 'CONSTRUCT_TRANSACTIONS', fingerprint, destinations },
    { expectReply: 'CONSTRUCTED_TRANSACTIONS' },
  );

  return reconstructTransactions(txs);
}
